import "./Card.css";

export default function Card({ hoverable = false, className = "", children, ...rest }) {
  return (
    <div
      className={`wc-card ${hoverable ? "wc-card-hoverable" : ""} ${className}`.trim()}
      {...rest}
    >
      {children}
    </div>
  );
}
